import React from 'react';
import { BackgroundLayer, LB_ACCENT_BLUE } from './atoms';
import { FlickeringGrid } from './FlickeringGrid';

export const LeaderboardBackground: React.FC = () => (
  <BackgroundLayer aria-hidden="true">
    <FlickeringGrid
      color={LB_ACCENT_BLUE}
      maxOpacity={0.16}
      edgeMaxOpacity={0.025}
      fadePower={1.2}
      flickerChance={0.28}
      squareSize={4}
      gridGap={6}
    />
  </BackgroundLayer>
);
